import Typography from "Components/CommonComponents/Typography";
import "./index.css";
function BranchhealthTip({ mode }: any) {
  // Create a new Date object for the current date
  const currentDate = new Date();
  const currentday = currentDate.getDate();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  let previousMonth = currentMonth - 1;
  let previousYear = currentYear;
  if (currentday < 5) {
    previousMonth = currentMonth - 2;
  }
  if (previousMonth < 0) {
    // If the previous month is negative, subtract 1 from the year and set the month to 11 (December)
    previousMonth = 11;
    previousYear -= 1;
  }
  const previousMonthDate = new Date(previousYear, previousMonth, 1);
  const monthName = previousMonthDate.toLocaleString("default", {
    month: "long",
  });
  console.log(
    previousMonth,
    currentMonth,
    currentday,
    "previousMonth",
    mode,
    monthName
  );

  return (
    <div className="headerInfoTipStyle">
      <Typography variant="subheading3" color="darkgray">
        Left out probability and follow-up data is for the month of {monthName}
      </Typography>
    </div>
  );
}
export default BranchhealthTip;
